import { jsx as s, jsxs as p } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import { toastBlueprint as u } from "./index-blueprint.es.js";
import { toast as T, Toaster as h } from "sonner";
import { useTranslate as g } from "@made-people/grease-translations";
import { StatusSuccessIcon as b, StatusErrorIcon as N } from "@made-people/blueprint-icons";
import "@made-people/blueprint";
const v = u.get(), w = Object.keys(v.variants.type), _ = e.object({
  variants: e.custom().optional(),
  children: e.custom().optional(),
  title: e.string().or(e.literal(!1)).optional(),
  description: e.string().optional(),
  dismissible: e.boolean().optional(),
  id: e.string().or(e.number()).optional(),
  className: e.string().optional(),
  type: e.enum(w).optional(),
  icons: e.object({
    success: e.custom().optional(),
    error: e.custom().optional(),
    warning: e.custom().optional()
  }).optional()
}), j = m(
  "Toast",
  y(
    {
      schema: _,
      defaultProps: {
        variants: {
          type: "info"
        },
        icons: {
          success: /* @__PURE__ */ s(b, {}),
          error: /* @__PURE__ */ s(N, {})
        }
      }
    },
    ({
      variants: t,
      className: i,
      children: n,
      title: a,
      description: l,
      type: d,
      dismissible: S,
      icons: r,
      id: x
    }) => {
      const o = u.styles(t), f = g(), c = {
        success: r == null ? void 0 : r.success,
        error: r == null ? void 0 : r.error,
        warning: r == null ? void 0 : r.warning
      }[d];
      return /* @__PURE__ */ s("div", { className: o.wrapper, children: /* @__PURE__ */ s("div", { className: o.container, children: /* @__PURE__ */ p("div", { className: o.content, children: [
        a && /* @__PURE__ */ p("p", { className: o.title, children: [
          c && /* @__PURE__ */ s("span", { className: o.icon, children: c }),
          f(a)
        ] }),
        l && /* @__PURE__ */ s("p", { className: o.description, children: l })
      ] }) }) });
    }
  )
);
function W(t) {
  let i;
  t.type === "error" ? i = "Toast_Error_Title" : t.type === "success" ? i = "Toast_Success_Title" : t.type === "warning" && (i = "Toast_Warning_Title");
  const n = (t == null ? void 0 : t.title) || i;
  return T.custom((a) => /* @__PURE__ */ s(
    j,
    {
      id: a,
      title: t.title ?? n,
      description: t.description,
      type: t.type,
      variants: {
        type: t.type ? { initial: t.type } : "info"
      }
    }
  ));
}
const Z = m(
  "Toaster",
  ({ position: t = "top-right" }) => /* @__PURE__ */ s(h, { position: t })
);
export {
  j as Toast,
  Z as Toaster,
  W as toast,
  _ as toastSchema
};
//# sourceMappingURL=index.es.js.map
